import * as React from "react";
/**
 * Component to render RegExp matches using a <mark> element.
 */
export class RegExpMarker extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    let content = this.renderMatches();
    return this.props.returnFragment ? /*#__PURE__*/React.createElement(React.Fragment, null, content) : /*#__PURE__*/React.createElement("div", {
      className: this.props.className
    }, content);
  }
  renderMatches() {
    let {
      text,
      regExp
    } = this.props;
    let content = [];
    let res = regExp.exec(text);
    if (res == null) {
      // No hit at all
      return text;
    }
    let startIndex = 0;
    while (res) {
      // We have at least 1 match
      let prefix = text.substring(startIndex, res.index);
      content.push(prefix);
      let match = res[0];
      content.push(/*#__PURE__*/React.createElement("mark", {
        key: startIndex
      }, match));
      startIndex = res.index + match.length;
      res = regExp.exec(text);
    }

    // Push the remaining text on
    content.push(text.substring(startIndex));
    return content;
  }
}
//# sourceMappingURL=RegExpMarker.js.map
